import { createApp } from "vue";
import CartPage from "./CartPage.vue";
import QuotePage from "./QuotePage.vue";
import { ioi_format_currency } from "./format_currency";

frappe.provide("ioi_partners")

window.ioi_format_currency = ioi_format_currency;

ioi_partners.shopping_cart = () => {
	const app = createApp(CartPage);
	window.SetVueGlobals(app)
	app.provide("ioi_format_currency", ioi_format_currency);
	app.mount("#cart");
}

// A quote's page ("My Quotes", www/my-quotes.html), from its #quote-data: the page data
// www/my_quotes.get_quote_page() made, as JSON escaped for a script element (tojson).
ioi_partners.quote_page = () => {
	const data = document.getElementById("quote-data")
	const app = createApp(QuotePage, { page: JSON.parse(data.textContent) });
	window.SetVueGlobals(app)
	app.mount("#quote");
}

$("body").find(".container").addClass("container-fluid").removeClass("container")